import { CERTIFICATE_LIST_FAIL,
         CERTIFICATE_LIST_REQUEST,
         CERTIFICATE_LIST_SUCCESS } from "../constants/certificateConstansts"



export const listCertificateReducers = (state = {certificate:[]} , action) => {
    switch(action.type){
        case CERTIFICATE_LIST_REQUEST:
            return { certificate: [] , loading: true}
        case CERTIFICATE_LIST_SUCCESS:
            return { certificate: action.payload , loading: false}
        case CERTIFICATE_LIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}





